import React from 'react';
import PropTypes from 'prop-types';

const DynamicScaleDisplay = ({
  scaleType, currentMeasurement, attributeLevel, minLabelForScale, maxLabelForScale,
}) => {
  const numberOfScales = [1, 2, 3, 4];

  return (
    <div className="dynamic-scale-display-container">
      <div className="measurement-header">
        <strong>{scaleType}</strong>
        :
        {' '}
        {currentMeasurement}
      </div>

      <div className="scales-wrapper">
        {numberOfScales.map((val) => (
          <div key={`dot-${val}`} className="scale-container">
            <span
              className={`dot ${attributeLevel === val ? 'big-dot' : 'small-dot'}`}
              aria-label={`Level ${val}`}
              role="img"
            />
          </div>
        ))}
      </div>

      <div className="scale-measurement-label">
        <span>{minLabelForScale}</span>
        <span>{maxLabelForScale}</span>
      </div>
    </div>
  );
};

DynamicScaleDisplay.propTypes = {
  scaleType: PropTypes.string.isRequired,
  currentMeasurement: PropTypes.string.isRequired,
  attributeLevel: PropTypes.oneOf([1, 2, 3, 4]).isRequired,
  minLabelForScale: PropTypes.string.isRequired,
  maxLabelForScale: PropTypes.string.isRequired,
};

export default DynamicScaleDisplay;
